import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

export type ManageItemTextProps = ComponentProps<"div"> & {
  primary: ReactNode
  secondary?: ReactNode
  tag?: ReactNode
  /**
   * A reason to think twice before acting on the row (a membership that
   * would cross customers). Rendered as an amber line under the text; the
   * row's action button is expected to confirm when this is set.
   */
  warning?: ReactNode
}

function ManageItemText(props: ManageItemTextProps) {
  const { primary, secondary, tag, warning, className, ...divProps } = props
  return (
    <div className={cn("manage-item-info", className)} {...divProps}>
      <span className="manage-item-primary">
        {primary}
        {tag && <span className="text-xs text-destructive ml-1">({tag})</span>}
      </span>
      {secondary && <span className="manage-item-secondary">{secondary}</span>}
      {warning && (
        <span className="manage-item-warning">
          <Icon src="triangle-warning" size={12} />
          {warning}
        </span>
      )}
    </div>
  )
}

export default ManageItemText
